export default function FilterIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      {...props}
    >
      <path
        d="M7 19C7 19.5523 7.44771 20 8 20C8.55228 20 9 19.5523 9 19V16.8293C8.68722 16.9398 8.35064 17 8 17C7.64936 17 7.31278 16.9398 7 16.8293L7 19Z"
        fill="currentColor"
      />
      <path
        d="M7 11.1707C7.31278 11.0602 7.64936 11 8 11C8.35064 11 8.68722 11.0602 9 11.1707L9 5C9 4.44772 8.55229 4 8 4C7.44772 4 7 4.44772 7 5L7 11.1707Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15ZM5 14C5 12.3431 6.34315 11 8 11C9.65685 11 11 12.3431 11 14C11 15.6569 9.65685 17 8 17C6.34315 17 5 15.6569 5 14Z"
        fill="currentColor"
      />
      <path
        d="M17 5C17 4.44772 16.5523 4 16 4C15.4477 4 15 4.44772 15 5V7.17071C15.3128 7.06015 15.6494 7 16 7C16.3506 7 16.6872 7.06015 17 7.17071V5Z"
        fill="currentColor"
      />
      <path
        d="M17 12.8293C16.6872 12.9398 16.3506 13 16 13C15.6494 13 15.3128 12.9398 15 12.8293V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V12.8293Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 9C15.4477 9 15 9.44772 15 10C15 10.5523 15.4477 11 16 11C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9ZM19 10C19 11.6569 17.6569 13 16 13C14.3431 13 13 11.6569 13 10C13 8.34315 14.3431 7 16 7C17.6569 7 19 8.34315 19 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
